import { Button } from '@/components/Common';
import { Modal } from '@/components/Layout';
import React from 'react';
import { useSettingUpTests } from './SettingUpTest.hook';
import { useExamStore } from '@/store/ExamStore/ExamStore';

const ExerciseDeletionModal = () => {
  const { isDeleteExercisePending, handleDeleteExercise } = useSettingUpTests();

  const { isOpenExerciseDeleteModal, setIsOpenExerciseDeleteModal } =
    useExamStore();

  return (
    <Modal
      isOpen={isOpenExerciseDeleteModal}
      onClose={() => setIsOpenExerciseDeleteModal(false)}
      modalStyle="bg-[#2A2A2A] min-w-[23.4375rem]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-white text-xl font-bold text-center mb-2">
          Supprimer l'exercice
        </h3>
        <p className="text-center text-gray-400 mx-auto my-0">
          Êtes-vous sûr de vouloir supprimer cet exercice ?
        </p>
        <div className="flex justify-between items-center gap-6 mt-4">
          <Button
            onClick={() => setIsOpenExerciseDeleteModal(false)}
            title="Annuler"
            className="!bg-completed hover:!outline-completed hover:!text-completed
              hover:!bg-hoverColor text-white !px-16"
          />
          <Button
            className="!px-16"
            title={
              isDeleteExercisePending ? 'Suppression en cours...' : 'Supprimer'
            }
            onClick={handleDeleteExercise}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ExerciseDeletionModal;
